import { JWT_KEY } from 'store';

export const getToken = (): string | undefined => localStorage.getItem(JWT_KEY) ?? undefined;
